import { render, staticRenderFns } from "./DialogPreviewQuestion.vue?vue&type=template&id=d370ac2a&scoped=true&"
import script from "./DialogPreviewQuestion.vue?vue&type=script&lang=js&"
export * from "./DialogPreviewQuestion.vue?vue&type=script&lang=js&"
import style0 from "./DialogPreviewQuestion.vue?vue&type=style&index=0&id=d370ac2a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d370ac2a",
  null
  
)

export default component.exports